import { IPageProps } from '../../interfaces/IPages';
import React from 'react';
import { Cabin } from '../components/sections/cabin/cabin';
import { TranslationService } from '../utils/translation-service';
import { LocaleConfigContext } from '../contexts/locale-config/locale-config';
import { getAssetsPrefix } from '../utils/buildVersion';

export const CabinMod = ({ getLandingPage, modulesData }: IPageProps) => {
    const localeConfig = React.useContext(LocaleConfigContext);
    const assetPrefix = getAssetsPrefix();
    const cabinFallbackBackground = `${assetPrefix}/static/images/ship-fallback-bg.jpg`;

    if (!modulesData || !modulesData[`ship${getLandingPage.id}`]) return null;

    const shipData = modulesData[`ship${getLandingPage.id}`];

    if (!shipData) return null;

    //Show the CTA button only when there are cabin subpage data.
    const showCabinPageCTA = Boolean(shipData.cabinInfoByType);

    const {
        title,
        minimumCabinSize,
        maximumCabinSize,
        numberOfCabins,
        cabinHeaderImage,
        bannerImage,
    } = shipData;

    const cabinFactsAndFigures = shipData.factsAndFigures;

    if (!cabinFactsAndFigures) return null;

    const cabinData = {
        passengers: cabinFactsAndFigures.passengerCapacity,
        title,
        decks: cabinFactsAndFigures.decks,
        numberOfCabins,
        smallestSquare: minimumCabinSize,
        biggestSquare: maximumCabinSize,
    };

    const imageUrl = cabinHeaderImage?.image.url || bannerImage || cabinFallbackBackground || '';
    const imagePlaceholder = cabinHeaderImage?.thumb.url || '';

    return (
        <Cabin
            key="cabin"
            heading={TranslationService.translate('cabinHeading')}
            description={TranslationService.translate('cabinDescription')}
            buttonText={TranslationService.translate('cabinButtonText')}
            cabinData={cabinData}
            redirectUrl={
                showCabinPageCTA
                    ? `/${getLandingPage.url}/${localeConfig.slugs.deck}`.replace('//', '/')
                    : null
            }
            imgUrl={imageUrl}
            placeholder={imagePlaceholder}
            shipName={title}
        />
    );
};
